module.exports = __webpack_public_path__ + "static/hitec_2024-cf9fe5c91514f92c7a027d979d7874b5.png";